import { useEffect, useState } from "react";
import { useApp } from "../../../hooks/AppProvider";
import { StudentCardsView } from "../../../components/StudentComponents";
import { SelectCell, Table } from "../../../components/BasicComponents";

function CardSelectGame({ st_card_id: id, st_card_name: name, st_card: student, games, wish, constraints, nextCalculationId, freez, onChange }) {    
    let [myWish, setMyWish] = useState(wish[String(id)]||[]);
    let [showAdd, setShowAdd] = useState(true);
    let [myGames, setMyGames] = useState([]);

    useEffect(() => {
        let filteredGame = games.filter(game => {
            if(constraints.gender.length !== 0) {
                const applicableConstraints = constraints.gender.filter(constraint => constraint.game_id+"" === game.id+"");

                if(applicableConstraints.length > 0) {
                let ok = false;
                for(let constraint of applicableConstraints) {
                    if(constraint.gender_id+"" === student.gender_id+"") {
                        ok = true;
                        break;
                    }
                }

                if(!ok)
                    return false;
                }
            }

            if(constraints.calculation.length !== 0) {
                const applicableConstraints = constraints.calculation.filter(constraint => constraint.game_id+"" === game.id+"");

                if(applicableConstraints.length > 0) {
                let ok = false;
                for(let constraint of applicableConstraints) {
                    if(constraint.calculation_id+"" === nextCalculationId+"") {
                        ok = true;
                        break;
                    }
                }

                if(!ok)
                    return false;
                }
            }

            if(constraints.grade.length !== 0) {
                const applicableConstraints = constraints.grade.filter(constraint => constraint.game_id+"" === game.id+"");

                if(applicableConstraints.length > 0) {
                let ok = false;
                for(let constraint of applicableConstraints) {
                    if(constraint.grade_id+"" === student.grade_id+"") {
                        ok = true;
                        break;
                    }
                }

                if(!ok)
                    return false;
                }
            }

            if(constraints.teacher.length !== 0) {
                const applicableConstraints = constraints.teacher.filter(constraint => constraint.game_id+"" === game.id+"");

                if(applicableConstraints.length > 0) {
                let ok = false;
                for(let constraint of applicableConstraints) {
                    if(constraint.teacher_id+"" === student.teacher_id+"") {
                        ok = true;
                        break;
                    }
                }

                if(!ok)
                    return false;
                }
            }

            return true;
        });

        setMyGames(filteredGame);
    }, [games, student, constraints]);

    useEffect(() => {
        setMyWish(wish[String(id)]||[]);
    }, [wish])

    useEffect(() => {
        if(myWish.includes("") || myWish.length >= myGames.length) {
            setShowAdd(false);
        }else
            setShowAdd(true);
    }, [myWish]);

    function change(e, index) {
        let newValue = Number(e.target.value);
        let oldI = myWish.indexOf(newValue);
        let oldValue = myWish[index];

        onChange(id, myWish.map((data, i) => {
            if(oldI != -1 && oldI == i) {
                return oldValue;
            }

            if(i == index) {
                return newValue;
            }
            return data;
        }));
    }

    function onAdd() {
        setMyWish([...myWish, ""]);
    }

    function onDelete(index) {
        onChange(id, myWish.filter((_, i) => i !== index));
    }
    
    return (
        <>
            <Table headers={["Voeux", ""]}>
                {myWish.map((data, index) => {                                                   
                    return (
                        <tr key={data}>
                            <SelectCell
                                value={data}
                                options={myGames.map(game => (
                                    {
                                        id: game.id,
                                        label: game.name + (myWish.some((e, i) => i != index && e == game.id) ? " (vœu " + (myWish.indexOf(Number(game.id)) + 1) + ")" : "")
                                    }))}
                                onChange={e => change(e, index)}
                                placeholder="- Choisir un jeu -"
                                disabled={freez}
                            />
                            <td>
                                <button className="button-delete" disabled={freez} onClick={() => onDelete(index)}>X</button>
                            </td>
                        </tr>
                    )
                })}
                
            </Table>
            <button onClick={onAdd} disabled={freez || !showAdd}>Ajouter</button>

        </>
    );
}

function Timer({ time }) {
    const [, setTick] = useState(0);
    useEffect(() => {
        const interval = setInterval(() => setTick(tick => tick + 1), 1000);
        return () => clearInterval(interval);
    }, []);

    if (!time || isNaN(new Date(time).getTime())) {
        return <span>Temps inconnu</span>;
    }
    const now = Date.now();
    const target = new Date(time).getTime();
    let secondsLeft = Math.max(0, Math.floor((target - now) / 1000));
    const days = Math.floor(secondsLeft / (60 * 60 * 24));
    const hours = Math.floor((secondsLeft % (60 * 60 * 24)) / (60 * 60));
    const minutes = Math.floor((secondsLeft % (60 * 60)) / 60);
    const seconds = secondsLeft % 60;

    return (
        <span>
            {days > 0 && `${days}j `}
            {hours.toString().padStart(2, '0')}h 
            {minutes.toString().padStart(2, '0')}m 
            {seconds.toString().padStart(2, '0')}s
        </span>
    );
}

function GameAssign() {

    let app = useApp();

    let [freez, setFreez] = useState(false);
    let [showCalcTimer, setShowCalcTimer] = useState(false);

    let [students, setStudents] = useState([]);
    let [games, setGames] = useState([]);
    let [wish, setWish] = useState({});

    const [genderConstraints, setGenderConstraints] = useState([]);
    const [calculationConstraints, setCalculationConstraints] = useState([]);
    const [gradeConstraints, setGradeConstraints] = useState([]);
    const [teacherConstraints, setTeacherConstraints] = useState([]);
    
    let [next, setNext] = useState([]);

    useEffect(() => {
        app.sendGet("/student/listmy", data => {
            setStudents(data);
        });

        app.sendGet("/game/list", data => {
            const games = [];
            for(let game of data) {
                let gameIndex = -1;
                if((gameIndex = games.findIndex(val => val.id === game.id)) !== -1)
                    games[gameIndex].constraints.push(game.gender_id);
                else 
                    games.push({id: game.id, name: game.name, capacity: game.capacity, constraints: game.gender_id!==null?[game.gender_id+""]:[]});
            }

            setGames(games);
        });

        app.sendGet("/game/listmy", data => {
            setWish(data);
        });

        app.sendGet("/game/calculations/next", data => {
            setNext({id: data.id, calculation: data.nextCalc, release: data.nextRelease});
        });

        app.sendGet("/game/constraints/gender", data => {
            setGenderConstraints(data);
        });

        app.sendGet("/game/constraints/calculation", data => {
            setCalculationConstraints(data);
        });

        app.sendGet("/game/constraints/grade", data => {
            setGradeConstraints(data);
        });

        app.sendGet("/game/constraints/teacher", data => {
            setTeacherConstraints(data);
        });
        
        function update30s() {
            app.sendGet("/game/freez", data => {
                setFreez(data.freez);
            });
        }

        update30s();

        let inter = setInterval(update30s, 30000);

        return () => clearInterval(inter);
    }, []);

    useEffect(() => {
        if(next.calculation && next.release) {
            setShowCalcTimer(next.calculation < next.release);
        }
    }, [next]);

    function onChange(id, newWish) {
        
        app.sendPost("/game/modify", {id: id, wish: newWish}, data => {
            if(data.success == false) {
                return alert("Error: " + data.message);
            }

            setWish(prevWish => ({
                ...prevWish,
                [id]: newWish
            }));
        });
    }

    return (
        <div className="main-content">
            <h1>Attribution des jeux</h1>
            {(next.calculation !== null || next.release !== null) && 
                (showCalcTimer ? (
                    <>
                        <h2>Prochaine attribution dans <Timer time={next.calculation} /></h2>
                    </>
                ) : (
                    <>
                        <h2>Prochaine remise à zéro dans <Timer time={next.release} /></h2>
                    </>
                ))
            }
            {freez && <><h2 className="error-text">Gel en cours, les vœux ne sont pas acceptés pour le moment.</h2></>}
            <hr />
            <StudentCardsView
                students={students}
                element={CardSelectGame}
                games={games}
                wish={wish}
                constraints={{
                    gender: genderConstraints,
                    calculation: calculationConstraints,
                    grade: gradeConstraints,
                    teacher: teacherConstraints
                }}
                nextCalculationId={next.id}
                onChange={onChange}
                freez={freez}
            >

                </StudentCardsView>
        </div>
    )
    
}

export default GameAssign;